import { createRef, Fragment, Component } from 'react';
import { getPairing } from '../../api/api';
import Header from './components/Header';
import Instructions from './components/Instructions';
import NutritionInfo from './components/NutritionInfo';
import PairingImage from './components/PairingImage';
import { getPairingDataImg, copySharableLink } from '../../utils/utils';
import Drawer from '../../generic/Drawer';
import PropTypes from 'prop-types';
import { RDPAddRemoveBtn } from '../../../../../components/RDP/RDPAddRemoveButton/RDPAddRemoveButton';
import {
  SaveRecipes,
  Variant as SaveVariant,
} from '../../../../../components/SaveRecipes/SaveRecipes';
import { windowVars } from '@hungryroot/environment';
import styles from './Rdp.module.css';
import { Ingredients } from '../../../../../pages/customize/components/Ingredients/Ingredients';
import { AuthGuard } from '../../../../../components/auth/AuthGuard/AuthGuard';
import { Loader } from '@hungryroot/plan';
import {
  Loading,
  LoadingVariant,
} from '@hungryroot/loading-component-primitives';

class Rdp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pairing: null,
      loading: true,
      drawerIngredients: [],
      swappableRecipesByIngredientId: {},
      drawerVisible: null,
      drawerSelectedIngredient: {},
    };
    this.drawerOverlay = createRef();
  }

  componentDidMount() {
    this.getPairingInfoById();
  }

  getPairingInfoById() {
    // @TODO: PAIRING ID IS DETERMINED FROM PATH, ALSO HAVE TO FILL IN QUOTE and IMG
    let pairing = this.props.pairing;
    if (!pairing) {
      pairing = window.pairingId;
    }
    if (typeof pairing === 'object') {
      this.setState({ pairing: pairing, loading: false });
    } else {
      getPairing(pairing)
        .then((result) => {
          if (this.props.onPairingLoad) this.props.onPairingLoad(result);
          this.setState({ pairing: result, loading: false });
        })
        .catch(console.error);
    }
  }

  renderFeaturedQuote() {
    let quote = this.state.pairing.featured_quote;
    if (quote && quote.indexOf('|') > -1) {
      return (
        <div className={'featuredQuote'}>
          <div className={'quote hr-title-sm'}>
            {quote.split('|')[0].trim()}
          </div>
          <div className={'quoteAttribution hr-paragraph'}>
            {quote.split('|')[1].trim()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  redirectToRecipePage(id) {
    if (!id) {
      console.error('no id provided to RDP click');
      return;
    }
    const foundPairing = this.state.pairing.ingredients.filter(
      (ele) => ele.id === id
    );
    if (foundPairing.length) {
      window.location.href = `${window.location.origin}/products/${foundPairing[0].slug}/`;
      return;
    }
  }

  // CUSTOMIZATION SPECIFIC METHODS:

  // Open Drawer gets the id of a clicked on ingredient and
  // sets up the drawer ingredients for display and click and
  // and swappabled recipes by ingredient to easy swap the rdp in the view
  // after user selection
  openDrawer(id) {
    // animate drawer overlay
    $(this.drawerOverlay.current).css({ display: 'block' });
    $(this.drawerOverlay.current).animate({ opacity: '.5' }, 300);

    if (!this.props.isCustomizationPage) return;
    // get recipes for the drawer and
    let recipes = this.props.swappableRecipes[id];
    // create a map of replaceableIngrediendId -> recipeToSwapTo
    let recipesByIngredient = {};
    // Array of selectable ingredients
    let drawerIngredients = [];
    // rdpRecipeIngredients variable is an array of the current rdp ingredients ids minus the selected one
    let rdpRecipeIngredients = this.state.pairing.ingredients
      .map((i) => i.id)
      .filter((iid) => iid !== id);

    recipes.forEach((recipe) => {
      // from ingredient selected swappable recipes get the ingredients
      let selectableIngredientArray = recipe.ingredients.filter(
        (i) => !rdpRecipeIngredients.includes(i.id)
      );
      // if there is more than 1 ingredient left don't consider the recipe:
      if (selectableIngredientArray.length > 1) return;

      let ingredientOption = selectableIngredientArray[0];
      let ingredientOptionId;
      // if ingredientOption exists add it to drawer ingredients to be displayed
      // otherwise a recipe exists with one less ingredient
      // so setting up option for it mapped to the 0 id.
      if (ingredientOption) {
        ingredientOptionId = ingredientOption.id;
        drawerIngredients.push(ingredientOption);
      } else {
        ingredientOptionId = 0;
        drawerIngredients.unshift({
          id: ingredientOptionId,
        });
      }
      // if there is 0 or more
      recipesByIngredient[ingredientOptionId] = recipe;
    });

    this.setState({
      drawerIngredients: drawerIngredients,
      swappableRecipesByIngredientId: recipesByIngredient,
      drawerVisible: true,
      drawerSelectedIngredient: this.state.pairing.ingredients.filter(
        (i) => i.id === id
      )[0],
    });
  }

  getPointsDiff(id) {
    if (this.props.savedRdpPairing) {
      return (
        this.state.swappableRecipesByIngredientId[id].points -
        this.props.savedRdpPairing.points
      );
    }
  }

  swapPairingByIngredient(id) {
    let newPairing = this.state.swappableRecipesByIngredientId[id];
    this.closeDrawer();
    this.setState(
      {
        pairing: newPairing,
      },
      () => {
        if (this.props.onPairingSwap) {
          this.props.onPairingSwap(newPairing);
        }
      }
    );
  }

  closeDrawer() {
    $(this.drawerOverlay.current).animate({ opacity: '0' }, 300, () => {
      $(this.drawerOverlay.current).css({ display: 'none' });
    });
    this.setState({
      drawerIngredients: [],
      swappableRecipesByIngredientId: {},
      drawerVisible: false,
      drawerSelectedIngredient: {},
    });
  }

  render() {
    if (!this.state.pairing) {
      return <></>;
    }

    if (this.props.loading) {
      return <Loading variant={LoadingVariant.TranslucentPopover} />;
    }

    let imgSrc = getPairingDataImg(this.state.pairing, 'src');

    let swappableIngredients = this.props.isCustomizationPage
      ? this.props.swappableRecipes
      : null;
    let showRemoveIngredientComponent =
      this.state.drawerIngredients.length &&
      this.state.drawerIngredients[0].id === 0;

    const recipeLink = `${window.location.origin}/recipes/${this.state.pairing.slug}/`;

    return (
      <div data-testid="modal-rdp" className={'rdp-customize pairing-card'}>
        {imgSrc ? (
          <div
            className="img-container"
            style={{ backgroundImage: `url(${imgSrc})` }}
          ></div>
        ) : (
          <PairingImage
            ingredients={this.state.pairing.ingredients}
            style="rdp"
          />
        )}
        {!windowVars.isPrecheckout() && (
          <AuthGuard
            authenticated={(auth) => {
              return (
                <SaveRecipes
                  pairingName={this.state.pairing.name}
                  customerId={this.props.customerId}
                  className={`${styles.save} ${styles['save-desktop']}`}
                  variant={SaveVariant.Card}
                  pairingId={this.state.pairing.id}
                  isFavorite={this.state.pairing.is_favorited}
                  testid={`rdp-save-${this.state.pairing.id}`}
                  segment={{
                    location: 'RDP',
                    path: this.props.segmentPath,
                  }}
                  onFavoriteChange={(isFavorite) => {
                    this.props.onFavoriteChange(this.state.pairing, isFavorite);
                  }}
                  customer={auth.customerData}
                />
              );
            }}
          />
        )}
        <div className="info-container">
          <Header
            pairingData={this.state.pairing}
            showRating={true}
            hideIcon={true}
            spicyTags={this.props.spicyTags}
          />

          <div className={'body-holder'}>
            {this.props.isCustomizationPage ? (
              <Ingredients
                ingredients={this.state.pairing.ingredients}
                swappableIngredients={swappableIngredients}
                openDrawer={(id) => this.openDrawer(id)}
              />
            ) : (
              <Ingredients
                ingredients={this.state.pairing.ingredients}
                onClick={(id) => this.redirectToRecipePage(id)}
              />
            )}
            {this.state.pairing.short_instruction_html && (
              <Instructions
                instructionsHtml={this.state.pairing.short_instruction_html}
                open={true}
                hideToggle={true}
              />
            )}
            <NutritionInfo nutritionHTML={this.state.pairing.nutrition_html} />

            {this.renderFeaturedQuote()}
            {this.props.isCustomizationPage ? (
              <Fragment>
                <RDPAddRemoveBtn
                  pairing={this.state.pairing}
                  closeModal={this.props.closeModal}
                />
                <Drawer
                  testid="rdp-drawer"
                  visible={this.state.drawerVisible}
                  close={() => this.closeDrawer()}
                >
                  <div className="hr-title-sm">
                    Select a chef-suggested ingredient:
                  </div>
                  <div className="drawer-selected-ingredient">
                    <Ingredients
                      ingredients={[this.state.drawerSelectedIngredient]}
                    />
                  </div>
                  <div className="drawer-ingredients">
                    <Ingredients
                      ingredients={
                        showRemoveIngredientComponent
                          ? this.state.drawerIngredients.slice(1)
                          : this.state.drawerIngredients
                      }
                      onClick={(id) => this.swapPairingByIngredient(id)}
                      getPointsDiff={(id) => this.getPointsDiff(id)}
                    />
                    {showRemoveIngredientComponent ? (
                      <div
                        className="remove-ingredient-btn"
                        onClick={() => this.swapPairingByIngredient(0)}
                      >
                        Remove
                      </div>
                    ) : null}
                  </div>
                </Drawer>
                <div
                  data-testid="rdp-drawer-overlay"
                  ref={this.drawerOverlay}
                  className="drawer-overlay"
                  onClick={() => this.closeDrawer()}
                ></div>
              </Fragment>
            ) : null}

            <div
              className="share-container hr-mb-8"
              onClick={(evt) => copySharableLink(evt)}
            >
              <div className="share-link-container">
                <div className="link-text">
                  <input
                    className="share-link hr-subtitle-md"
                    name="link"
                    value={recipeLink}
                    readOnly={true}
                  />
                </div>
                <div className="copy-button hr-bold">Copy</div>
              </div>
            </div>
          </div>
          <span
            data-testid="close"
            className="close"
            onClick={this.props.closeModal}
          ></span>
          {!windowVars.isPrecheckout() && (
            <AuthGuard
              authenticated={(auth) => {
                <SaveRecipes
                  pairingName={this.state.pairing.name}
                  customerId={this.props.customerId}
                  className={`${styles.save} ${styles['save-mobile']}`}
                  variant={SaveVariant.RDP}
                  pairingId={this.state.pairing.id}
                  isFavorite={this.state.pairing.is_favorited}
                  segment={{
                    location: 'RDP',
                    path: 'congrats',
                  }}
                  testid={`mobile-rdp-save-${this.state.pairing.id}`}
                  onFavoriteChange={(isFavorite) => {
                    this.props.onFavoriteChange(this.state.pairing, isFavorite);
                  }}
                  customer={auth.customerData}
                />;
              }}
            />
          )}
          {!this.props.isCustomizationPage ? (
            <div className="btm-liner-gradient"></div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Rdp;

Rdp.propTypes = {
  closeModal: PropTypes.func,
  pairing: PropTypes.any,
  swappableRecipes: PropTypes.object,
  isCustomizationPage: PropTypes.bool,
  onPairingSwap: PropTypes.func,
};
